export enum CommunicationMethodTypes {
  email = 'email',
  text = 'text',
  kiosk = 'kiosk',
  myScreen = 'my screen',
  none = '',
}
